<div *ngIf="loadAPIcall" class="hpanel gs-cardpost-box-shadow">
  <app-common-skeleton *ngIf="loadAPIcall" [countforView]="7"
    [NameOftheScreen]="'candidateDetails'"></app-common-skeleton>
</div>
<ng-container *ngIf="!loadAPIcall">
  <!-- Wireframe About cards (gigsumo-inapp-company-page-Opti.html, panel-about). Styled only
       in this component's scss under .gs-bp-*; the previous hpanel cards follow below behind
       !useWireframeProfile. -->
  <ng-container *ngIf="useWireframeProfile">
    <div class="gs-bp-card">
      <div class="gs-bp-hd">
        <div class="gs-bp-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          {{ canEdit ? 'About Us' : 'About' }}
        </div>
        <button *ngIf="canEdit" type="button" class="gs-bp-edit" title="Edit about company" (click)="aboutEdit()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>Edit
        </button>
      </div>
      <div class="gs-bp-about">
        <ng-container *ngIf="!infoData?.aboutCompany || infoData?.aboutCompany == '<p><br></p>'">
          <p *ngIf="canEdit" class="gs-bp-empty">Please write something of your company</p>
          <p *ngIf="businessData?.isSuperAdmin != 'true' && businessData?.isAdmin != 'true'" class="gs-bp-empty">{{businessName + " "}}hadn't provided anything here</p>
        </ng-container>
        <div [ngxSummernoteView]="infoData?.aboutCompany"></div>
      </div>
    </div>

    <div class="gs-bp-card">
      <div class="gs-bp-hd">
        <div class="gs-bp-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
          Business Details
        </div>
        <button *ngIf="canEdit" type="button" class="gs-bp-edit" title="Edit business details" (click)="busDetailEdit(busDetailTemplate)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>Edit
        </button>
      </div>
      <div class="gs-bp-grid">
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Business Name</div><div class="gs-bp-value">{{ businessName || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Tagline</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!(tagLine && tagLine.trim())">{{ (tagLine && tagLine.trim()) ? tagLine : '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Industry Classification</div>
            <div class="gs-bp-value">{{ (infoData?.industryClassification == 'OTHER' ? infoData?.others : industryClass) || '—' }}</div></div>
        </div>
        <div class="gs-bp-item" *ngIf="hCareFlag">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Facility / Practice Type</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!facilityPracticeType">{{ facilityPracticeType || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Company Type</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!companyType">{{ companyType || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Organization Type</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!organizationType">{{ organizationType || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Year Started</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!yearStarted">{{ yearStarted || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Company Size</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!companysize">{{ companysize || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">State of Incorporation</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!stateOfIncorporation">{{ stateOfIncorporation || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="6" y1="10" x2="12" y2="10"/><line x1="6" y1="14" x2="10" y2="14"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">FEIN Number</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!feinNumber">{{ feinNumber || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Diversity Status</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!diversityStatus">{{ diversityStatus || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Revenue</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!revenue">{{ revenue || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Locations Serviced</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!locationsServiced">{{ locationsServiced || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Website</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!websiteUrl">
              <a *ngIf="websiteUrl; else noWebsite" [href]="socialHref(websiteUrl)" target="_blank" rel="noopener noreferrer">{{ websiteUrl }}</a>
              <ng-template #noWebsite>—</ng-template>
            </div></div>
        </div>
      </div>
    </div>

    <div class="gs-bp-card">
      <div class="gs-bp-hd">
        <div class="gs-bp-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
          Location Details
        </div>
        <button *ngIf="canEdit" type="button" class="gs-bp-edit" title="Add company location" (click)="locationEdit(locationTemplate, null, 'add', false)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>Add
        </button>
      </div>
      <p *ngIf="!infoData?.companyLocationDetails?.length" class="gs-bp-empty gs-bp-note">No locations added yet.</p>
      <div class="gs-bp-loc" *ngFor="let location of infoData?.companyLocationDetails; let i = index;">
        <div class="gs-bp-grid">
          <div class="gs-bp-item">
            <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg></div>
            <div class="gs-bp-body">
              <div class="gs-bp-label">Address <span *ngIf="location.headquarters" class="gs-bp-hq">HQ</span></div>
              <div class="gs-bp-value" [class.gs-bp-value--empty]="!locationAddress(location)">{{ locationAddress(location) || '—' }}</div>
            </div>
          </div>
          <div class="gs-bp-item">
            <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6z"/></svg></div>
            <div class="gs-bp-body"><div class="gs-bp-label">Phone</div>
              <div class="gs-bp-value" [class.gs-bp-value--empty]="!location.businessPhone">{{ location.businessPhone || '—' }}</div></div>
          </div>
          <div class="gs-bp-item" *ngIf="location.website">
            <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg></div>
            <div class="gs-bp-body"><div class="gs-bp-label">Website</div>
              <div class="gs-bp-value"><a [href]="socialHref(location.website)" target="_blank" rel="noopener noreferrer">{{ location.website }}</a></div></div>
          </div>
        </div>
        <div class="gs-bp-loc-actions" *ngIf="canEdit">
          <button type="button" class="gs-bp-edit" title="Edit location details" (click)="locationEdit(locationTemplate, i, 'edit', location.headquarters)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>Edit
          </button>
          <button type="button" class="gs-bp-edit gs-bp-edit--danger" title="Delete location details" (click)="removeLocation(i)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>Delete
          </button>
        </div>
      </div>
    </div>

    <div class="gs-bp-card" *ngIf="hCareFlag">
      <div class="gs-bp-hd">
        <div class="gs-bp-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
          Service Options
        </div>
        <button *ngIf="canEdit" type="button" class="gs-bp-edit" title="Edit service options" (click)="physicianEdit(physicianTemplate, $event)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>Edit
        </button>
      </div>
      <div class="gs-bp-grid">
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Accreditions</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!accredition">{{ accredition || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Type of Services</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!serviceType">{{ serviceType || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Insurance Accepted</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!insuranceAccepted">{{ insuranceAccepted || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Medicare Certified</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!medicareCertified">{{ medicareCertified || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Accepting New Patients</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!acceptingNewPatients">{{ acceptingNewPatients || '—' }}</div></div>
        </div>
        <div class="gs-bp-item">
          <div class="gs-bp-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg></div>
          <div class="gs-bp-body"><div class="gs-bp-label">Private Pay Accepted</div>
            <div class="gs-bp-value" [class.gs-bp-value--empty]="!privatePayAccepted">{{ privatePayAccepted || '—' }}</div></div>
        </div>
      </div>
    </div>

    <div class="gs-bp-card">
      <div class="gs-bp-hd">
        <div class="gs-bp-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
          Social Media
        </div>
        <button *ngIf="canEdit" type="button" class="gs-bp-edit" title="Edit social presence" (click)="userSocialPresenceEdit(socialPresenceTemplate)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>Edit
        </button>
      </div>
      <div class="gs-bp-social-row">
        <ng-container *ngTemplateOutlet="socialChip; context: { url: linkedin, name: 'LinkedIn', key: 'linkedin' }"></ng-container>
        <ng-container *ngTemplateOutlet="socialChip; context: { url: twitter, name: 'X', key: 'x' }"></ng-container>
        <ng-container *ngTemplateOutlet="socialChip; context: { url: facebook, name: 'Facebook', key: 'facebook' }"></ng-container>
        <ng-container *ngTemplateOutlet="socialChip; context: { url: instagramUrl, name: 'Instagram', key: 'instagram' }"></ng-container>
        <ng-container *ngTemplateOutlet="socialChip; context: { url: youtubeUrl, name: 'YouTube', key: 'youtube' }"></ng-container>
        <ng-container *ngTemplateOutlet="socialChip; context: { url: tiktokUrl, name: 'TikTok', key: 'tiktok' }"></ng-container>
        <ng-container *ngTemplateOutlet="socialChip; context: { url: blogURL, name: 'Blog', key: 'blog' }"></ng-container>
        <ng-container *ngTemplateOutlet="socialChip; context: { url: alternamePageLink, name: 'Alternate Page', key: 'alternate' }"></ng-container>
        <span *ngIf="!canEdit && !linkedin && !twitter && !facebook && !instagramUrl && !youtubeUrl && !tiktokUrl && !blogURL && !alternamePageLink"
          class="gs-bp-empty gs-bp-note">No social links added yet.</span>
      </div>
    </div>

    <!-- Filled link → solid chip that opens it. Missing → dashed "Add …" chip, admins only,
         opening the same Social Presence modal as the card's Edit. -->
    <ng-template #socialChip let-url="url" let-name="name" let-key="key">
      <ng-container *ngIf="url || canEdit">
        <a *ngIf="url" class="gs-bp-chip gs-bp-chip--filled" [href]="socialHref(url)" target="_blank" rel="noopener noreferrer" [title]="url">
          <ng-container *ngTemplateOutlet="socialIcon; context: { key: key }"></ng-container>
          <span class="gs-bp-chip-text">{{ socialLabel(url) }}</span>
        </a>
        <button *ngIf="!url" type="button" class="gs-bp-chip" (click)="userSocialPresenceEdit(socialPresenceTemplate)">
          <ng-container *ngTemplateOutlet="socialIcon; context: { key: key }"></ng-container>
          Add {{ name }}
        </button>
      </ng-container>
    </ng-template>

    <ng-template #socialIcon let-key="key">
      <ng-container [ngSwitch]="key">
        <svg *ngSwitchCase="'linkedin'" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
        <svg *ngSwitchCase="'x'" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231z"/></svg>
        <svg *ngSwitchCase="'facebook'" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
        <svg *ngSwitchCase="'instagram'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
        <svg *ngSwitchCase="'youtube'" viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#fff"/></svg>
        <svg *ngSwitchCase="'tiktok'" viewBox="0 0 24 24" fill="currentColor"><path d="M19.6 6.7a4.8 4.8 0 0 1-3.8-4.2V2h-3.4v13.4a2.9 2.9 0 1 1-2-2.7V9.2a6.3 6.3 0 1 0 5.4 6.2V8.6a8.2 8.2 0 0 0 3.8 1.2V6.7z"/></svg>
        <svg *ngSwitchCase="'blog'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
        <svg *ngSwitchDefault viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
      </ng-container>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="!useWireframeProfile">
  <div class="hpanel gs-cardpost-box-shadow">
    <div class="panel-heading gs-card-headerhbuilt ">
      <div class="pull-right btn-group">
        <p *ngIf="(businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true') && businessData.viewingAsMember != 'true'">About Us</p>
        <p *ngIf="(businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true') && businessData.viewingAsMember == 'true'">About</p>
        <p *ngIf="businessData?.isSuperAdmin != 'true' && businessData?.isAdmin != 'true'">About</p>
      </div>
      <div *ngIf="(businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true') && businessData?.viewingAsMember != 'true'" class="pull-right btn-group">
        <div class="col-sm-2" style="margin: -5px -12px 0px 0px;" title="Edit about company"
          (click)="aboutEdit()">
          <button class="edit-pencil gs-icon-btn"><span>
              <ng-icon name="tablerPencil" class="icon-over" style="cursor: pointer; color: #60686f!important;font-size: 15px;"></ng-icon>
            </span></button>
        </div>
      </div>

    </div>
    <div class="panel-body gs-card-bodygs-card-body" style="word-wrap: break-word;line-break: anywhere;">

      <div *ngIf="(businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true') && businessData?.viewingAsMember != 'true'">
        <div
          *ngIf="infoData?.aboutCompany==null || infoData?.aboutCompany==undefined || infoData?.aboutCompany=='' || infoData?.aboutCompany == '<p><br></p>'">
          <p style=" margin-bottom: -2px;">Please write something of your company</p>
        </div>
      </div>
      <div *ngIf="businessData?.isSuperAdmin != 'true' && businessData?.isAdmin != 'true'">
        <div
          *ngIf="infoData?.aboutCompany==null || infoData?.aboutCompany==undefined || infoData?.aboutCompany=='' || infoData?.aboutCompany == '<p><br></p>'">
          <p style=" margin-bottom: -2px;">{{businessName + " "}}hadn't provided anything here</p>
        </div>
      </div>

      <div [ngxSummernoteView]="infoData?.aboutCompany"></div>

    </div>
  </div>
  <div class="hpanel gs-cardpost-box-shadow">
    <div class="panel-heading gs-card-headerhbuilt">
      <div>
        Business Details
      </div>
      <div *ngIf="(businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true') && businessData?.viewingAsMember != 'true'" class="pull-right btn-group">
        <div class="col-sm-2" style="margin: -5px -12px 0px 0px;" title="Edit business details"
          (click)="busDetailEdit(busDetailTemplate)">
          <button class="edit-pencil gs-icon-btn"><span>
              <ng-icon name="tablerPencil" class="icon-over" style="cursor: pointer; color: #60686f!important;font-size: 15px;"></ng-icon>
            </span></button>
        </div>
      </div>
    </div>
    <div class="panel-body gs-card-bodygs-card-body" style="word-wrap: break-word;line-break: anywhere;">
      <div class="row form-group">
        <div class="col-sm-4">Business Name</div>
        <div class="col-sm-8 tagline-container">{{businessName}}</div>
      </div>
      <div class="row form-group">
        <div class="col-sm-4">Tagline</div>
        <ng-container *ngIf="tagLine && tagLine.trim() !== ''; else zp">
          <div class="col-sm-8 tagline-container">{{ tagLine }}</div>
        </ng-container>
        <ng-template #zp>
          <div class="col-sm-8">None</div>
        </ng-template>
      </div>

      <div class="row form-group">
        <div class="col-sm-4">Industry Classification</div>
        <div class="col-sm-8" *ngIf="infoData?.industryClassification!='OTHER'">{{industryClass}}</div>
        <div class="col-sm-8" *ngIf="infoData?.industryClassification=='OTHER'">{{infoData?.others}}</div>
      </div>
      <div class="row form-group" *ngIf="hCareFlag">
        <div class="col-sm-4">Facility / Practice Type</div>
        <div class="col-sm-8">{{facilityPracticeType}}</div>
      </div>
      <div class="row form-group">
        <div class="col-sm-4">Company Type</div>
        <div *ngIf="companyType!=undefined&&
                          companyType!=null&&
                          companyType!=''" else #zp class="col-sm-8">{{companyType}}</div>
        <div class="col-sm-8" *ngIf="companyType==undefined||
                                          companyType==null||
                                          companyType==''">
          <p>None</p>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-4">Organization Type</div>
        <div *ngIf="organizationType!=undefined&&
                          organizationType!=null&&
                          organizationType!=''" else #zp class="col-sm-8">{{organizationType}}</div>
        <div class="col-sm-8" *ngIf="organizationType==undefined||
                                          organizationType==null||
                                          organizationType==''">
          <p>None</p>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-4">Year Started</div>
        <div *ngIf="yearStarted!=undefined&&
                          yearStarted!=null&&
                          yearStarted!=''" else #zp class="col-sm-8">{{yearStarted}}</div>
        <div class="col-sm-8" *ngIf="yearStarted==undefined||
                                          yearStarted==null||
                                          yearStarted==''">
          <p>None</p>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-4">Company Size</div>
        <div *ngIf="companysize!=undefined&&
                          companysize!=null&&
                          companysize!=''" else #zp class="col-sm-8">{{companysize}}</div>
        <div class="col-sm-8" *ngIf="companysize==undefined||
                                          companysize==null||
                                          companysize==''">
          <p>None</p>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-4">State of Incorporation</div>
        <div *ngIf="stateOfIncorporation" class="col-sm-8">{{stateOfIncorporation}}</div>
        <div class="col-sm-8" *ngIf="!stateOfIncorporation"><p>None</p></div>
      </div>
      <div class="row form-group">
        <div class="col-sm-4">FEIN Number</div>
        <div *ngIf="feinNumber" class="col-sm-8">{{feinNumber}}</div>
        <div class="col-sm-8" *ngIf="!feinNumber"><p>None</p></div>
      </div>
      <div class="row form-group">
        <div class="col-sm-4">Diversity Status</div>
        <div *ngIf="diversityStatus" class="col-sm-8">{{diversityStatus}}</div>
        <div class="col-sm-8" *ngIf="!diversityStatus"><p>None</p></div>
      </div>
      <div class="row form-group">
        <div class="col-sm-4">Revenue</div>
        <div *ngIf="revenue" class="col-sm-8">{{revenue}}</div>
        <div class="col-sm-8" *ngIf="!revenue"><p>None</p></div>
      </div>
      <div class="row form-group">
        <div class="col-sm-4">Locations Serviced</div>
        <div *ngIf="locationsServiced" class="col-sm-8">{{locationsServiced}}</div>
        <div class="col-sm-8" *ngIf="!locationsServiced"><p>None</p></div>
      </div>
      <div class="row form-group">
        <div class="col-sm-4">Website URL</div>
        <div *ngIf="websiteUrl" class="col-sm-8">
          <a [href]="websiteUrl" target="_blank" style="word-break: break-all;">{{websiteUrl}}</a>
        </div>
        <div class="col-sm-8" *ngIf="!websiteUrl"><p>None</p></div>
      </div>
    </div>
  </div>

  <div class="hpanel gs-cardpost-box-shadow">
    <div class="panel-heading gs-card-headerhbuilt">
      <div>
        Location Details
      </div>
      <div *ngIf="(businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true') && businessData?.viewingAsMember != 'true'" class="pull-right btn-group">
        <!-- <div class="col-sm-2" style="margin: -5px -12px 0px 0px;"title="Edit location details"
               (click)="locationEdit(locationTemplate)">
                  <button class="edit-pencil gs-icon-btn"><span>
                      <ng-icon name="tablerPencil" style="cursor: pointer; color: #60686f; !important;font-size: 15px;"></ng-icon>
                  </span></button>
              </div> -->
        <div class="col-sm-2" title="Add company location" (click)="locationEdit(locationTemplate, null, 'add',false)"
          style=" padding-left: 3px;
              margin-top: -2px;">
          <ng-icon name="tablerPlus" class="btn btn-xs btn-cirrr"></ng-icon>
        </div>

        <!-- <div class="col-sm-1">
                  <ng-icon name="tablerTrash" (click)="removeLocation(i)"
                       title="Delete Location" style="cursor: pointer"></ng-icon>
                  </div> -->
      </div>
    </div>
    <div class="panel-body gs-card-bodygs-card-body" style="word-wrap: break-word;line-break: anywhere;">
      <div *ngFor="let location of infoData?.companyLocationDetails; let lastItem = last; let i = index;">
        <div class="row form-group">
          <div class="col-sm-4"> Address </div>
          <div class="col-sm-6 address-container">

            <span>
              <span *ngIf="location.address1">{{location.address1}}, </span>
               <span *ngIf="location.address2"> {{location.address2}}, </span>
               <span *ngIf="location.street"> {{location.street}}, </span>
               <span *ngIf="location.city!=null&& location.city!=undefined">{{location.city}}, </span>
               <br>
               <span *ngIf="location.state!=null&& location.state!=undefined">  {{location.state}}, </span>
              <span style="display: inline-block;" *ngFor="let country of countryList">
                <p *ngIf="country.countryCode == location.country">{{country.countryName}}, </p></span>
              <span *ngIf="location.country!=null&& location.country!=undefined"> {{location.zipCode}}.</span>
            </span>


          </div>
          <!-- *ngIf="values.adminviewnavigation && !location.headquarters &&
          infoData?.companyLocationDetails.length > 1"  -->
          <div class="col-sm-1 btn-group"
            *ngIf="(businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true') && businessData?.viewingAsMember != 'true'"
            style="margin: -5px -12px 0px 0px;" title="Delete location details" (click)="removeLocation(i)">
            <button class="edit-pencil gs-icon-btn"><span>
                <ng-icon name="tablerTrash" class="icon-over" style="cursor: pointer; color: #60686f!important;font-size: 15px;"></ng-icon>
              </span></button>
          </div>

          <div class="col-sm-1 btn-group"
            *ngIf="(businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true') && businessData?.viewingAsMember != 'true'"
            style="margin: -5px -12px 0px 0px;" title="Edit location details"
            (click)="locationEdit(locationTemplate,i,'edit',location.headquarters)">
            <button class="edit-pencil gs-icon-btn"><span>
                <ng-icon name="tablerPencil" class="icon-over" style="cursor: pointer; color: #60686f!important;font-size: 15px;"></ng-icon>
              </span></button>
          </div>

        </div>

        <div class="row form-group" *ngIf="location.headquarters">
          <div class="col-sm-4">
            Headquarter
          </div>
          <div class="col-sm-6" underlined>
            Yes
          </div>
        </div>

        <div class="row form-group">
          <div class="col-sm-4">
            Phone
          </div>
          <div class="col-sm-6" underlined>
            {{location.businessPhone}}
          </div>
        </div>
        <div class="row form-group" *ngIf="location.website">
          <div class="col-sm-4">
            Website
          </div>
          <div class="col-sm-6">
            <a [attr.href]="location.website.includes('http://') ? location.website : 'http://'+location.website"
              target="_blank">{{location.website}}</a>
          </div>
        </div>
        <hr *ngIf="!lastItem">
      </div>
    </div>
  </div>

  <div class="hpanel gs-cardpost-box-shadow" *ngIf="hCareFlag">
    <div class="panel-heading gs-card-headerhbuilt ">
      <!-- <div class="pull-right" *ngIf="values.viewadmin">
              <a (click)="physicianEdit(physicianTemplate,$event)">
                  <ng-icon name="tablerPencil"></ng-icon>
                  Edit
              </a>
          </div> -->
      <div>
        Service Options
      </div>
      <div *ngIf="(businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true') && businessData?.viewingAsMember != 'true'" class="pull-right btn-group">
        <div class="col-sm-2" style="margin: -5px -12px 0px 0px;" title="Edit service options"
          (click)="physicianEdit(physicianTemplate, $event)">
          <button class="edit-pencil gs-icon-btn"><span>
              <ng-icon name="tablerPencil" class="icon-over" style="cursor: pointer; color: #60686f!important;font-size: 15px;"></ng-icon>
            </span></button>
        </div>
      </div>
    </div>
    <div class="panel-body gs-card-bodygs-card-body">
      <div class="row form-group">
        <div class="col-sm-4">
          <!-- <label class="control-label">Accreditions</label> -->
          Accreditions
        </div>
        <div *ngIf="accredition!=undefined&&
                          accredition!=null&&
                          accredition!=''" class="col-sm-8">
          <p>{{accredition}}</p>
        </div>
        <div *ngIf="accredition==undefined||
                          accredition==null||
                          accredition==''" class="col-sm-8">
          <p>None</p>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-4">
          <!-- <label class="control-label">Type of Services</label> -->
          Type of Services
        </div>
        <div class="col-sm-8" *ngIf="serviceType!=undefined&&
                          serviceType!=null&&
                          serviceType!=''">
          <p>{{serviceType}}</p>
        </div>
        <div class="col-sm-8" *ngIf="serviceType==undefined||
                          serviceType==null||
                          serviceType==''">
          <p>None</p>
        </div>
      </div>
      <div class="row form-group ">
        <div class="col-sm-4">
          <!-- <label class="control-label">Insurance Accepted</label> -->
          Insurance Accepted
        </div>
        <div class="col-sm-8" *ngIf="insuranceAccepted!=undefined&&
                          insuranceAccepted!=null&&
                          insuranceAccepted!=''">
          <p>{{insuranceAccepted}}</p>
        </div>
        <div class="col-sm-8" *ngIf="insuranceAccepted==undefined||
                          insuranceAccepted==null||
                          insuranceAccepted==''">
          <p>None</p>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-4">
          <!-- <label class="control-label">Medicare Certified</label> -->
          Medicare Certified
        </div>
        <div class="col-sm-8">
          <p>{{medicareCertified}}</p>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-sm-4">
          <!-- <label class="control-label">Accepting New Patients</label> -->
          Accepting New Patients
        </div>
        <div class="col-sm-8">
          <p>{{acceptingNewPatients}}</p>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-sm-4">
          <!-- <label class="control-label">Private Pay Accepted</label> -->
          Private Pay Accepted
        </div>
        <div class="col-sm-8">
          <p>{{privatePayAccepted}}</p>
        </div>
      </div>
    </div>
  </div>



  <!-- <div class="hpanel gs-cardpost-box-shadow padding-right-5 margin-bottom-5">
  <div class="panel-heading gs-card-headerhbuilt ">
    <div *ngIf="(businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true') && businessData?.viewingAsMember != 'true'" class="pull-right btn-group">
      <div class="col-sm-2" style="margin: -5px -12px 0px 0px;" title="Edit working hours"
        (click)="hoursEdit(hourTemplate)">
        <button class="edit-pencil gs-icon-btn"><span>
            <ng-icon name="tablerPencil" class="icon-over" style="cursor: pointer; color: #60686f!important;font-size: 15px;"></ng-icon>
          </span></button>
      </div>
    </div>
    Working Hours
  </div>
  <div class="panel-body gs-card-bodygs-card-body">
    <p *ngIf="(!monWork && !tueWork && !thrWork && !wedWork && !friWork
         && !satWork && !sunWork); else workDays"><span *ngIf="(businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true') && businessData?.viewingAsMember != 'true'">You haven't provided
        business working
        hours yet</span>
      <span *ngIf="businessData?.isSuperAdmin != 'true' && businessData?.isAdmin != 'true'">{{businessName}} hadn't provided their working hours yet</span>
    </p>

    <ng-template #workDays>
      <div class="row form-group" style="font-weight: 600;">
        <div class="col-sm-4">
           Working Days
        </div>
        <div class="col-sm-4">
          Opens At
        </div>
        <div class="col-sm-4">
          <p>Closes At</p>
        </div>
      </div>


      <div *ngIf="monWork" class="row form-group">
        <div class="col-sm-4">
           Monday
        </div>
        <div class="col-sm-4">
          <p>{{monFrom}}</p>
        </div>
        <div class="col-sm-4">
          <p>{{monTo}}</p>
        </div>
      </div>
      <div *ngIf="tueWork" class="row form-group">
        <div class="col-sm-4">
           Tuesday
        </div>
        <div class="col-sm-4">
          <p>{{tueFrom}}</p>
        </div>
        <div class="col-sm-4">
          <p>{{tueTo}}</p>
        </div>
      </div>
      <div *ngIf="wedWork" class="row form-group">
        <div class="col-sm-4">
           Wednesday
        </div>
        <div class="col-sm-4">
          <p>{{wedFrom}}</p>
        </div>
        <div class="col-sm-4">
          <p>{{wedTo}}</p>
        </div>
      </div>
      <div *ngIf="thrWork" class="row form-group">
        <div class="col-sm-4">
           Thursday
        </div>
        <div class="col-sm-4">
          <p>{{thrFrom}}</p>
        </div>
        <div class="col-sm-4">
          <p>{{thrTo}}</p>
        </div>
      </div>
      <div *ngIf="friWork" class="row form-group">
        <div class="col-sm-4">
           Friday
        </div>
        <div class="col-sm-4">
          <p>{{friFrom}}</p>
        </div>
        <div class="col-sm-4">
          <p>{{friTo}}</p>
        </div>
      </div>
      <div *ngIf="satWork" class="row form-group">
        <div class="col-sm-4">
           Saturday
        </div>
        <div class="col-sm-4">
          <p>{{satFrom}}</p>
        </div>
        <div class="col-sm-4">
          <p>{{satTo}}</p>
        </div>
      </div>
      <div *ngIf="sunWork" class="row form-group">
        <div class="col-sm-4 ">
           Sunday
        </div>
        <div class="col-sm-4">
          <p>{{sunFrom}}</p>
        </div>
        <div class="col-sm-4">
          <p>{{sunTo}}</p>
        </div>
      </div>
    </ng-template>


  </div>
</div> -->

  <form [formGroup]="userPrivacyForm" class="app-form">
    <div class="hpanel gs-cardapp-form">
      <div class="panel-heading gs-card-headerhbuilt">
        <div>
          Social Presence
        </div>
        <div class="pull-right" *ngIf="(businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true') && businessData?.viewingAsMember != 'true'">
          <div *ngIf="(businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true') && businessData?.viewingAsMember != 'true'"
            class="pull-right btn-group">
            <div class="col-sm-2" style="margin: -5px -12px 0px 0px;" title="Edit social presence"
              (click)="userSocialPresenceEdit(socialPresenceTemplate)">
              <button class="edit-pencil gs-icon-btn"><span>
                  <ng-icon name="tablerPencil" class="icon-over" style="cursor: pointer; color: #60686f!important;font-size: 15px;"></ng-icon>
                </span></button>
            </div>
          </div>



        </div>
      </div>
      <div class="panel-body gs-card-bodygs-card-body" style="word-wrap: break-word;line-break: anywhere;">
        <div style="padding-bottom: 30px; padding-top: 10px;">
          <div
            *ngIf="(linkedin==null||linkedin==undefined||linkedin=='') && (twitter==null|| twitter==undefined||twitter=='')&&
            (facebook==undefined|| facebook==null|| facebook=='') && (blogURL==undefined||blogURL==null||blogURL=='')&&
            (alternamePageLink==null||alternamePageLink==null||alternamePageLink=='') && !youtubeUrl && !instagramUrl && !tiktokUrl && ((businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true') && businessData?.viewingAsMember != 'true')">
            <p>You haven't added any of your social presence yet</p>
          </div>

          <div
            *ngIf="(linkedin==null||linkedin==undefined||linkedin=='') && (twitter==null|| twitter==undefined||twitter=='')&&
            (facebook==undefined|| facebook==null|| facebook=='') && (blogURL==undefined||blogURL==null||blogURL=='')&&
            (alternamePageLink==null||alternamePageLink==null||alternamePageLink=='') && !youtubeUrl && !instagramUrl && !tiktokUrl && (businessData?.isSuperAdmin != 'true' && businessData?.isSuperAdmin != 'true')">
            <p>{{businessName}} hadn't provided their social present yet</p>
          </div>
          <div class="col-sm-12">
            <div class="row form-group" *ngIf="linkedin">
              <div class="col-sm-1">
                <ng-icon name="simpleLinkedin" style="color:  #0e76a8;"></ng-icon>
              </div>
              <div class="col-sm-11">
                {{linkedin}}
              </div>
            </div>
            <div class="row form-group" *ngIf="twitter">
              <div class="col-sm-1">
                <ng-icon name="customX" class="icon-over" style="color: #000000;"></ng-icon>
              </div>
              <div class="col-sm-11">
                {{twitter}}
              </div>
            </div>
            <div class="row form-group" *ngIf="facebook">
              <div class="col-sm-1">
                <ng-icon name="simpleFacebook" class="icon-over" style="color:  #3b5998;"></ng-icon>
              </div>
              <div class="col-sm-11">
                {{facebook}}
              </div>
            </div>
            <div class="row form-group" *ngIf="blogURL">
              <div class="col-sm-1">
                <ng-icon name="tablerFileText" class="icon-over" style="color: midnightblue;"></ng-icon>
              </div>
              <div class="col-sm-11">
                {{blogURL}}
              </div>
            </div>
            <div class="row form-group" *ngIf="alternamePageLink">
              <div class="col-sm-1">
                <ng-icon name="tablerLayoutGrid" class="icon-over" style="color: black;"></ng-icon>
              </div>
              <div class="col-sm-11">
                {{alternamePageLink}}
              </div>
            </div>
            <div class="row form-group" *ngIf="youtubeUrl">
              <div class="col-sm-1">
                <ng-icon name="simpleYoutube" class="icon-over" style="color: #FF0000;"></ng-icon>
              </div>
              <div class="col-sm-11">
                <a [href]="youtubeUrl" target="_blank" style="word-break: break-all;">{{youtubeUrl}}</a>
              </div>
            </div>
            <div class="row form-group" *ngIf="instagramUrl">
              <div class="col-sm-1">
                <ng-icon name="simpleInstagram" class="icon-over" style="color: #C13584;"></ng-icon>
              </div>
              <div class="col-sm-11">
                <a [href]="instagramUrl" target="_blank" style="word-break: break-all;">{{instagramUrl}}</a>
              </div>
            </div>
            <div class="row form-group" *ngIf="tiktokUrl">
              <div class="col-sm-1">
                <ng-icon name="simpleTiktok" class="icon-over" style="color: #000000;"></ng-icon>
              </div>
              <div class="col-sm-11">
                <a [href]="tiktokUrl" target="_blank" style="word-break: break-all;">{{tiktokUrl}}</a>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </form>
  </ng-container>
</ng-container>


<ng-template #templateNested1>
  <div class="modal-dialog">
    <div class="modal-content">
      <div style="justify-content: center; display: flex; padding: 10px;">
        <img style="height: 80px; width: 80px;" src="assets/icon/warning.png">
      </div>
      <h5 class="text-center">Are you sure?</h5>
      <div class="modal-body" style="padding: 0px 0px 0px 22px; justify-content: center; display: flex">
        <p>Types of service and Accreditions on Service Options depend on this, changing this would erase them.
          Do you wish to continue?</p><br>
      </div>
      <div class="row" style="padding: 10px;">
        <div class="col-sm-6">
          <button (click)="onHidden()" class="btn btn-default btn-block">Cancel</button>
        </div>
        <div class="col-sm-6">
          <button (click)="clearService()" class="btn primary-btn btn-block">Continue</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #busDetailTemplate>

  <div class="common-header-flex">
    <div>Business Details </div>
    <button>
      <span class="common-close" (click)="modalRef.hide()">&times;</span>
    </button>
  </div>

  <form [formGroup]="busDetailForm" class="app-form form-horizontal">
    <div class="panel-body gs-card-bodygs-card-body">
      <div class="form-group row" style="margin-bottom: 0px;">
        <div class="col-sm-3" style="padding-left: 54px;margin-bottom: -5px;"
          *ngIf="photoId != undefined || photoId != null">
          <img class="img-circle m-b m-t-md" height="90px" width="90px" [src]="img.src">
        </div>

        <div *ngIf="photoId == undefined || photoId == null" style="padding-left: 54px;margin-bottom: -5px;"
          class="col-sm-3">
          <img class="img-circle m-b m-t-md" height="90px" width="90px" src="assets/images/gallery/company.png">
        </div>
        <div class="col-sm-9" style="padding-right: 46px;">
          <label for="industryClassification" class="margin-bottom-5 control-label required-field  font-light">Industry
            Classification</label>
          <select class="form-control input-sm" formControlName="industryClassification"
            (change)="onChangeIndustry($event.target.value)">
            <option value="null" selected disabled>Industry Classification</option>

            <option *ngFor="let industry of industryType" [value]="industry">{{industry}}
            </option>
          </select>
          <div
            *ngIf="detailControl.industryClassification.invalid && (detailControl.industryClassification.dirty || detailControl.industryClassification.touched)"
            class="error-msg">
            <div *ngIf="detailControl.industryClassification.errors.required"> This field is required
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row" *ngIf="otherFlag1">
        <label for="other" class="col-sm-3 control-label required-field font-light">Other</label>
        <div class="col-sm-9" style="padding-right: 46px;">
          <input type="text" class="form-control input-sm" placeholder="Other Industry Classification"
            formControlName="others">
          <div *ngIf=" detailControl.others.invalid" class="error-msg" style="padding-right: 31px;">
            <div *ngIf="detailControl.others.errors.required"> This field is required</div>
            <!-- <div *ngIf="detailControl.others.errors.pattern" style="color: #c3002f; float: right">Please
                avoid unwanted spaces</div> -->
          </div>

        </div>

      </div>

      <div class="form-group row" *ngIf="hCareFlag1">
        <label for="facilityPracticeType" class="col-sm-3 control-label required-field font-light">Facility
          / Practice Type</label>
        <div class="col-sm-9" style="padding-right: 46px;">
          <select class="form-control input-sm" (change)="onChngFacility($event.target.value, templateNested1)"
            formControlName="facilityPracticeType">
            <!-- <option></option> -->
            <option value="null" selected disabled>Facility / Practice Type</option>
            <option *ngFor="let facility of facilityValue" [value]="facility">{{facility}}</option>
          </select>
          <div style="margin-right: 32px;" *ngIf="detailControl.facilityPracticeType.invalid" class="error-msg">
            <div *ngIf="detailControl.facilityPracticeType.errors.required"> This field is required
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="businessName" class="col-sm-3 control-label required-field font-light">Business
          Name</label>
        <div class="col-sm-9" style="padding-right: 46px;">
          <input type="text" class="form-control input-sm" placeholder="Business Name" formControlName="businessName">
          <div style="margin-right: 33px;" *ngIf="detailControl.businessName.invalid &&
                                  (detailControl.businessName.dirty || detailControl.businessName.touched)"
            class="error-msg">
            <div *ngIf="detailControl.businessName.errors.required"> Business Name is required</div>
            <div *ngIf="detailControl.businessName.errors?.maxlength">
              {{ FORMERROR.ORGANIZATION_NAME_MAX }}
            </div>
            <div *ngIf="detailControl.businessName.errors.pattern" class="text-danger">Please avoid
              unwanted spaces</div>
          </div>
        </div>

      </div>

      <div class="form-group row">
        <label for="tagLine" class="col-sm-3 control-label font-light">Tag Line</label>
        <div class="col-sm-9" style="padding-right: 46px;">
          <input type="text" maxlength="141" class="form-control input-sm" placeholder="Tag Line" trim="blur"
            formControlName="tagLine" (keypress)="checkSpace($event)">
          <div class="error-msg" style="margin-right: 30px;">
            <div *ngIf="detailControl.tagLine.errors?.pattern">
              {{FORMERROR.TAGLINE_PATTERN}}
            </div>
            <div *ngIf="detailControl.tagLine.errors?.maxword">
              {{FORMERROR.TAGLINE_MAX}}
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label for="businessLogo" class="col-sm-3 control-label font-light">Logo</label>
        <div class="col-sm-9" style="padding-right: 46px;">
          <ng-template #template>

            <div class="common-header-flex">
              <div>Logo</div>
              <button>
                <span class="common-close" (click)="closePhoto()">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1 / 1"
                format="jpeg" (imageCropped)="imageCropped($event)" (cropperReady)="cropperReady()"
                (loadImageFailed)="loadImageFailed()">
              </image-cropper>
            </div>

            <div class="custom-panel-footer">
              <div class="panel-footer">
                <div class="footer-flex">
                  <button class="btn btn-default" (click)="closePhoto()">Cancel</button>
                  <button class="btn btn-primary" (click)="imageLoaded()">Apply</button>
                </div>
              </div>
            </div>

          </ng-template>
          <!-- formControlName="businessLogo" -->
          <input type="file" accept=".jpg, .jpeg, .png" id="profileimage" #myFileInput (click)="myFileInput.value=null"
            class="form-control  " (change)="fileChangeEvent($event,template)" />
        </div>
      </div>

      <div class="form-group row">
        <label for="companyType" class="col-sm-3 control-label font-light">Company Type</label>
        <div class="col-sm-9" style="padding-right: 46px;">
          <select class="form-control input-sm" formControlName="companyType">
            <option value="null" selected disabled>Company Type</option>
            <option *ngFor="let company of companyTypeList" [value]="company">{{company}}</option>

          </select>


        </div>
      </div>

      <div class="form-group row">
        <label for="organizationType" class="col-sm-3 control-label required-field font-light">Organization Type</label>
        <div class="col-sm-9" style="padding-right: 46px;">
          <select class="form-control input-sm" formControlName="organizationType">
            <option [ngValue]="null" [disabled]="true">Organization Type</option>
            <option *ngFor="let organizationType of clientTypeList" [value]="organizationType">
              {{ organizationType }}
            </option>
          </select>
          <div style="margin-right: 32px;"
            *ngIf="detailControl.organizationType.invalid && (detailControl.organizationType.dirty || detailControl.organizationType.touched)"
            class="error-msg">
            <div *ngIf="detailControl.organizationType.errors?.required"> This field is required</div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="yearStarted" class="col-sm-3 control-label  font-light">Year Started</label>
        <div class="col-sm-9" style="padding-right: 46px;">
          <select type="text" formControlName="yearStarted" class="form-control input-sm">
            <option value="null" selected disabled>Year Started</option>
            <option *ngFor="let year of years" [value]="year">{{year}}</option>
          </select>

        </div>
      </div>
      <div class="form-group row">
        <label for="companySize" class="col-sm-3 control-label font-light">Company Size</label>
        <div class="col-sm-9" style="padding-right: 46px;">
          <select type="text" formControlName="companySize" class="form-control input-sm">
            <option value="null" selected disabled>Company Size</option>
            <option *ngFor="let size of companySize" [value]="size.code">{{size.code}}</option>
          </select>

        </div>
      </div>

      <div class="form-group row">
        <label for="busStateOfIncorporationInput" class="col-sm-3 control-label font-light">State of Incorporation</label>
        <div class="col-sm-9" style="padding-right: 46px;">
          <input type="text" class="form-control input-sm" placeholder="e.g., Texas" id="busStateOfIncorporationInput" formControlName="stateOfIncorporation">
        </div>
      </div>

      <div class="form-group row">
        <label for="feinNumber" class="col-sm-3 control-label font-light">FEIN Number</label>
        <div class="col-sm-9" style="padding-right: 46px;">
          <input type="text" class="form-control input-sm" placeholder="XX-XXXXXXX" formControlName="feinNumber">
        </div>
      </div>

      <div class="form-group row">
        <label for="diversityStatus" class="col-sm-3 control-label font-light">Diversity Status</label>
        <div class="col-sm-9" style="padding-right: 46px;">
          <select class="form-control input-sm" formControlName="diversityStatus">
            <option value="" selected disabled>Select diversity status</option>
            <option value="NONE">None</option>
            <option value="MBE">MBE (Minority-Owned)</option>
            <option value="WBE">WBE (Women-Owned)</option>
            <option value="SDVOSB">SDVOSB (Service-Disabled Veteran)</option>
            <option value="8(a)">8(a)</option>
            <option value="HUBZone">HUBZone</option>
            <option value="LGBTQ+">LGBTQ+</option>
            <option value="Veteran">Veteran-Owned</option>
          </select>
        </div>
      </div>

      <div class="form-group row">
        <label for="revenue" class="col-sm-3 control-label font-light">Revenue</label>
        <div class="col-sm-9" style="padding-right: 46px;">
          <select class="form-control input-sm" formControlName="revenue">
            <option value="" selected disabled>Select revenue range</option>
            <option value="&lt; $1M">&lt; $1M</option>
            <option value="$1M-$5M">$1M–$5M</option>
            <option value="$5M-$10M">$5M–$10M</option>
            <option value="$10M-$50M">$10M–$50M</option>
            <option value="$50M+">$50M+</option>
          </select>
        </div>
      </div>

      <div class="form-group row">
        <label for="locationsServiced" class="col-sm-3 control-label font-light">Locations Serviced</label>
        <div class="col-sm-9" style="padding-right: 46px;">
          <input type="text" class="form-control input-sm" placeholder="e.g., US-Nationwide, CA, TX" formControlName="locationsServiced">
        </div>
      </div>

      <div class="form-group row">
        <label for="websiteUrl" class="col-sm-3 control-label font-light">Website URL</label>
        <div class="col-sm-9" style="padding-right: 46px;">
          <input type="url" class="form-control input-sm" placeholder="https://www.example.com" formControlName="websiteUrl">
        </div>
      </div>

      <!-- <div class="form-group row">
          <label for="tags" class="col-sm-3 control-label font-light"> #Tags</label>
          <div class="col-sm-9" style="padding-right: 46px;">
            <div >
              <ng-select [isOpen]="false" [addTag]="true" [multiple]="true" maxSelectedItems="3" addTagText="Add #Tag:"
                bindLabel="name" [closeOnSelect]="true" [hideSelected]="false" placeholder="Options to add 3 #tags only"
                [(ngModel)]="tagSelectedItems" formControlName="tags">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <div class="ng-select-checkbox-label">
                    <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                    <span class="ng-select-checkbox-text">{{item}}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>

          </div>
        </div> -->

    </div>
  </form>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default " (click)="decline()">
          Cancel
        </button>
        <button class="btn primary-btn " type="button" (click)="infoSave()">
          Submit
        </button>
      </div>
    </div>
  </div>

</ng-template>

<!-- <ng-template #aboutTemplate>
  <div class="hpanel gs-card">
    <div class="panel-heading gs-card-header">
      <div class="row panel-tools">
        <button type="button" class="close pull-left" aria-label="Close" (click)="modalRef.hide()">
          <span style="padding-right: 22px;font-size: 26px;line-height: 0px;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <label class="control-label padding-top-0 margin-bottom-5 margin-top-5" style="margin-left: 8px;">About
        Company</label>
    </div>
    <div class="panel-body gs-card-bodygs-card-body">
      <form [formGroup]="aboutCompanyForm" class="custom-form">
        <div class="row">
          <div class="form-group">
            <div class="col-sm-12">
              <div formControlName="aboutCompany" id="aboutCompany" [ngxSummernote]="config">
              </div>
              <div class="error-msg" *ngIf="a.aboutCompany.invalid">
                <div *ngIf="a.aboutCompany.errors.maxlength">
                  Maximum characters allowed is 1000
                </div>
              </div>
            </div>
          </div>
        </div>

      </form>

    </div>
    <div class="row">
      <div class="text-right" style="padding-right: 49px; padding-top: 7px; padding-bottom: 7px;">
        <button class="btn default-btn" (click)="decline()">
          Cancel
        </button>
        <button class="btn primary-btn " style="margin-left:2%;" type="button"
          [disabled]="!aboutCompanyForm.valid" (click)="aboutSave()">
          Submit
        </button>

      </div>
    </div>
  </div>
</ng-template> -->


<!-- <p>Small modal window have small width on screens only above 768px(boostrap3) and 576px(bootstrap4)</p> -->
<!-- <button class="btn btn-primary" (click)="lgModal.show()">Large modal</button> -->

<div bsModal #lgModal="bs-modal" (onShown)="focusAboutEditor()" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">


      <div class="common-header-flex">
        <div>About Company</div>
        <button>
          <span (click)="closeModal()" class="common-close">&times;</span>
        </button>
      </div>

      <div class="panel-body gs-card-bodygs-card-body">
        <form [formGroup]="aboutCompanyForm" class="custom-form">
          <div class="row">
            <div class="form-group">
              <div class="col-sm-12 R-summary">
                <div formControlName="aboutCompany" id="aboutCompany" [ngxSummernote]="config2">
                </div>
                <div  class="text-danger" *ngIf="amsubmit&&!a.aboutCompany.errors?.minchar"> About Company is required</div>
                <div class="text-danger" *ngIf="a.aboutCompany.invalid">
                  <div *ngIf="a.aboutCompany.errors?.maxchar">
                    {{FORMERROR.ABOUT_YOURSELF_MAX}}
                  </div>
                  <div *ngIf="a.aboutCompany.errors?.minchar">
                    {{FORMERROR.ABOUT_YOUR_MIN}}
                  </div>

                </div>
              </div>
              <div class="col-sm-6">
                <!-- <label><small>Maximum characters allowed is 1000</small></label> -->
              </div>
              <div class="col-sm-6 text-right" *ngIf="!a.aboutCompany.errors?.maxword">
                <label>
                  <small>
                    <span>{{remainingCharacters}}</span>
                    Characters remaining
                  </small>
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>


      <div class="custom-panel-footer">
        <div class="panel-footer">
          <div class="footer-flex">
            <button class="btn btn-default" (click)="decline1()">
              Cancel
            </button>
            <button  class="btn primary-btn" (click)="aboutSave()">
              Submit
            </button>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>


<ng-template #physicianTemplate>
  <div class="hpanel gs-card">
    <div class="panel-heading gs-card-header">
      <div class="row panel-tools">
        <div class="col-sm-2" style="margin: -5px;">
          <button type="button" class="close pull-left" aria-label="Close" (click)="closeOptions()">
            <span style="padding-right: 8px;font-weight: 400;font-size: 26px;" aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <label class="control-label padding-top-0 margin-bottom-5 margin-top-5" style="margin-left: 8px;">Service
        Options</label>

    </div>
    <div class="panel-body gs-card-bodygs-card-body" style="padding-left: 40px;">
      <form [formGroup]="serviceForm" class="form-horizontal app-form" style="margin-top: 11px">
        <div class="form-group row">
          <label for="accredition" class="col-sm-4 control-label font-normal">Accredition</label>
          <div class="col-sm-7">
            <!-- <input [typeahead]="accreditionValue" [typeaheadMinLength]="0"
                              class="form-control input-sm" placeholder="Accredition"  formControlName="accredition"> -->
            <div >
              <ng-select [addTag]="true" [items]="accreditionValue" [multiple]="false" [closeOnSelect]="true"
                [hideSelected]="true" dropdownPosition="bottom" placeholder="Accredition" formControlName="accredition">
              </ng-select>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="serviceType" class="col-sm-4 control-label font-normal">Type of Services</label>
          <div class="col-sm-7">
            <div >
              <ng-select [items]="serviceTypeList" [addTag]="true" [multiple]="true" [hideSelected]="false"
                dropdownPosition="bottom" placeholder="Type of Services" [(ngModel)]="serviceSelectedItems"
                formControlName="serviceType">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <div class="ng-select-checkbox-label">
                    <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                    <span class="ng-select-checkbox-text">{{item}}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="insuranceAccepted" class="col-sm-4 control-label font-normal">Insurance Accepted</label>
          <div class="col-sm-7">
            <div >
              <ng-select [items]="insuranceList" [multiple]="true" [addTag]="true" [hideSelected]="false"
                dropdownPosition="bottom" placeholder="Insurance Accepted" [(ngModel)]="insuranceSelectedItems"
                formControlName="insuranceAccepted">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <div class="ng-select-checkbox-label">
                    <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                    <span class="ng-select-checkbox-text">{{item}}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label for="medicareCertified" class="col-sm-4 control-label font-normal">Medicare Certified</label>
          <div class="col-sm-7">
            <div class="row">
              <div class="col-sm-3" style="  padding-top: 4px;">
                <div class="custom-checkbox" style="margin-top: 5px;">
                  <label class="checkbox-label font-normal" style="text-align: center;"> Yes
                    <input type="radio" [value]="true" formControlName="medicareCertified" name="medicareCertified">
                    <span title="Check Working Days" class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-3" style="  padding-top: 4px;">
                <div class="custom-checkbox" style="margin-top: 5px;">
                  <label class="checkbox-label font-normal" style="text-align: center;"> No
                    <input type="radio" [value]="false" formControlName="medicareCertified" name="medicareCertified">
                    <span title="Check Working Days" class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row form-group ">
          <label for="acceptingNewPatients" class="col-sm-4 control-label font-normal">Accepting New
            Patients</label>
          <div class="col-sm-7">
            <div class="row">
              <div class="col-sm-3" style="  padding-top: 4px;">
                <div class="custom-checkbox" style="margin-top: 5px;">
                  <label class="checkbox-label font-normal" style="text-align: center;"> Yes
                    <input type="radio" [value]="true" formControlName="acceptingNewPatients"
                      name="acceptingNewPatients">
                    <span title="Check Working Days" class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-3" style="  padding-top: 4px;">
                <div class="custom-checkbox" style="margin-top: 5px;">
                  <label class="checkbox-label font-normal" style="text-align: center;"> No
                    <input type="radio" [value]="false" formControlName="acceptingNewPatients"
                      name="acceptingNewPatients">
                    <span title="Check Working Days" class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="privatePayAccepted" class="col-sm-4 control-label font-normal">Private Pay Accepted</label>
          <div class="col-sm-7">
            <div class="row">
              <div class="col-sm-3" style="  padding-top: 4px;">
                <div class="custom-checkbox" style="margin-top: 5px;">
                  <label class="checkbox-label font-normal" style="text-align: center;"> Yes
                    <input type="radio" [value]="true" formControlName="privatePayAccepted" name="privatePayAccepted">
                    <span title="Check Working Days" class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-3" style="  padding-top: 4px;">
                <div class="custom-checkbox" style="margin-top: 5px;">
                  <label class="checkbox-label font-normal" style="text-align: center;"> No
                    <input type="radio" [value]="false" formControlName="privatePayAccepted" name="privatePayAccepted">
                    <span title="Check Working Days" class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="text-right" style="padding-right: 64px; padding-top: 7px; padding-bottom: 7px;">
      <button class="btn default-btn " (click)="closeOptions()">
        Cancel
      </button>
      <button class="btn primary-btn " style="margin-left:2%;" type="button" (click)="physicianSave()">
        Submit
      </button>

    </div>
  </div>
</ng-template>

<ng-template #hourTemplate>
  <div class="hpanel gs-cardapp">
    <div class="panel-heading gs-card-header">
      <div class="row panel-tools">
        <div class="col-sm-2" style="margin: -5px;">
          <button type="button" class="close pull-left" aria-label="Close" (click)="modalRef.hide()">
            <span style="padding-right: 9px;font-weight: 400;font-size: 26px;color: #fff;color: #fff;"
              aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <label class="control-label padding-top-0 margin-bottom-5 margin-top-5"
        style="margin-left: 8px;font-size:17px;color: #fff;">Working
        Hours</label>

    </div>

    <div class="panel-body gs-card-bodygs-card-body">
      <form [formGroup]="hoursForm" class="form-horizontal app-form">
        <div class="form-group row">
          <div class="col-sm-3">
            <div class="custom-checkbox" style="margin-top: 5px;">
              <label class="checkbox-label font-normal" style="text-align: center;"> Monday
                <input type="checkbox" formControlName="monWorking" name="monWorking" (click)="doHours($event)">
                <span title="Check Working Days" class="checkmark"></span>
              </label>
            </div>
          </div>


          <div class="col-sm-4">
            <select formControlName="monFromTime" class="form-control input-sm" (change)="frmHr($event)">
              <option value="null" disabled selected>Opens</option>
              <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
            </select>
            <div class="error-msg" *ngIf="hourControl.monFromTime.invalid">
              <div *ngIf="hourControl.monFromTime.errors.required">Please fill this out</div>
            </div>
          </div>

          <div class="col-sm-4">
            <select formControlName="monToTime" class="form-control input-sm" (change)="toHr($event)">
              <option value="null" selected disabled>Closes</option>
              <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
            </select>
            <div class="error-msg" *ngIf="hourControl.monToTime.invalid">
              <div *ngIf="hourControl.monToTime.errors.required">Please fill this out</div>
            </div>
          </div>

        </div>
        <div class="form-group row" style="margin-left: 142px;margin-top: -7px; margin-bottom: 14px;" *ngIf="worktime">
          <!-- <div class="null"> -->
          <div class="custom-checkbox" style="margin-top: 5px;">
            <label class="checkbox-label font-normal" style="text-align: center;"> Apply this schedule for
              all
              <input type="checkbox" formControlName="applyAll" name="applyAll" (change)="changeHours($event)">
              <span class="checkmark"></span>
            </label>
          </div>
          <!-- </div> -->
        </div>
        <div class="form-group row">


          <div class="col-sm-3">
            <div class="custom-checkbox" style="margin-top: 5px;">
              <label class="checkbox-label font-normal" style="text-align: center;"> Tuesday
                <input type="checkbox" formControlName="tueWorking" (change)="tue($event)" name="tueWorking">
                <span title="Check Working Days" class="checkmark"></span>
              </label>
            </div>
          </div>


          <div class="col-sm-4">
            <select formControlName="tueFromTime" class="form-control input-sm" placeholder="Opens"
              (change)="fromHrOtherDay($event)">
              <option value="null" selected disabled>Opens</option>
              <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
            </select>
            <div class="error-msg" *ngIf="tuetrue&&hourControl.tueFromTime.invalid">
              <div *ngIf="hourControl.tueFromTime.errors.required">Please fill this out</div>
            </div>
          </div>
          <div class="col-sm-4">
            <select formControlName="tueToTime" class="form-control input-sm" (change)="toHrOtherDay($event)">
              <option value="null" selected disabled>Closes</option>
              <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
            </select>
            <div class="error-msg" *ngIf="tuetrue&&hourControl.tueToTime.invalid">
              <div *ngIf="hourControl.tueToTime.errors.required">Please fill this out</div>
            </div>
          </div>

        </div>
        <div class="form-group row">
          <div class="col-sm-3">
            <div class="custom-checkbox" style="margin-top: 5px;">
              <label class="checkbox-label font-normal" style="text-align: center;"> Wednesday
                <input type="checkbox" (change)="wed($event)" formControlName="wedWorking" name="wedWorking">
                <span title="Check Working Days" class="checkmark"></span>
              </label>
            </div>
          </div>


          <div class="col-sm-4">
            <select formControlName="wedFromTime" class="form-control input-sm" (change)="fromHrOtherDay($event)">
              <option value="null" selected disabled>Opens</option>
              <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
            </select>
            <div class="error-msg" *ngIf="hourControl.wedFromTime.invalid">
              <div *ngIf="hourControl.wedFromTime.errors.required">Please fill this out</div>
            </div>
          </div>
          <div class="col-sm-4">
            <select formControlName="wedToTime" class="form-control input-sm" (change)="toHrOtherDay($event)">
              <option value="null" selected disabled>Closes</option>
              <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
            </select>
            <div class="error-msg" *ngIf="hourControl.wedToTime.invalid">
              <div *ngIf="hourControl.wedToTime.errors.required">Please fill this out</div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-3">
            <div class="custom-checkbox" style="margin-top: 5px;">
              <label class="checkbox-label font-normal" style="text-align: center;"> Thursday
                <input type="checkbox" formControlName="thrWorking" (change)="thu($event)" name="thrWorking">
                <span title="Check Working Days" class="checkmark"></span>
              </label>
            </div>
          </div>

          <div class="col-sm-4">
            <select formControlName="thrFromTime" class="form-control input-sm" placeholder="Opens"
              (change)="fromHrOtherDay($event)">
              <option value="null" selected disabled>Opens</option>
              <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
            </select>
            <div class="error-msg" *ngIf="hourControl.thrFromTime.invalid">
              <div *ngIf="hourControl.thrFromTime.errors.required">Please fill this out</div>
            </div>
          </div>
          <div class="col-sm-4">
            <select formControlName="thrToTime" class="form-control input-sm" (change)="toHrOtherDay($event)">
              <option value="null" selected disabled>Closes</option>
              <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
            </select>
            <div class="error-msg" *ngIf="hourControl.thrToTime.invalid">
              <div *ngIf="hourControl.thrToTime.errors.required">Please fill this out</div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-3">
            <div class="custom-checkbox" style="margin-top: 5px;">
              <label class="checkbox-label font-normal" style="text-align: center;"> Friday
                <input type="checkbox" formControlName="friWorking" (change)="fri($event)" name="friWorking">
                <span title="Check Working Days" class="checkmark"></span>
              </label>
            </div>
          </div>

          <div class="col-sm-4">
            <select formControlName="friFromTime" class="form-control input-sm" placeholder="Opens"
              (change)="fromHrOtherDay($event)">
              <option value="null" selected disabled>Opens</option>
              <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
            </select>
            <div class="error-msg" *ngIf="hourControl.friFromTime.invalid">
              <div *ngIf="hourControl.friFromTime.errors.required">Please fill this out</div>
            </div>
          </div>
          <div class="col-sm-4">
            <select formControlName="friToTime" class="form-control input-sm" (change)="toHrOtherDay($event)">
              <option value="null" selected disabled>Closes</option>
              <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
            </select>
            <div class="error-msg" *ngIf="hourControl.friToTime.invalid">
              <div *ngIf="hourControl.friToTime.errors.required">Please fill this out</div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-3">
            <div class="custom-checkbox" style="margin-top: 5px;">
              <label class="checkbox-label font-normal" style="text-align: center;"> Saturday
                <input type="checkbox" formControlName="satWorking" (change)="sat($event)" name="satWorking">
                <span title="Check Working Days" class="checkmark"></span>
              </label>
            </div>
          </div>
          <div class="col-sm-4">
            <select formControlName="satFromTime" class="form-control input-sm" placeholder="Opens"
              (change)="fromHrOtherDay($event)">
              <option value="null" selected disabled>Opens</option>
              <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
            </select>
            <div class="error-msg" *ngIf="hourControl.satFromTime.invalid">
              <div *ngIf="hourControl.satFromTime.errors.required">Please fill this out</div>
            </div>
          </div>
          <div class="col-sm-4">
            <select formControlName="satToTime" class="form-control input-sm" (change)="toHrOtherDay($event)">
              <option value="null" selected disabled>Closes</option>
              <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
            </select>
            <div class="error-msg" *ngIf="hourControl.satToTime.invalid">
              <div *ngIf="hourControl.satToTime.errors.required">Please fill this out</div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-3">
            <div class="custom-checkbox" style="margin-top: 5px;">
              <label class="checkbox-label font-normal" style="text-align: center;"> Sunday
                <input type="checkbox" formControlName="sunWorking" (change)="sun($event)" name="sunWorking">
                <span title="Check Working Days" class="checkmark"></span>
              </label>
            </div>
          </div>
          <div class="col-sm-4">
            <select formControlName="sunFromTime" class="form-control input-sm" placeholder="Opens"
              (change)="fromHrOtherDay($event)">
              <option value="null" selected disabled>Opens</option>
              <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
            </select>
            <div class="error-msg" *ngIf="hourControl.sunFromTime.invalid">
              <div *ngIf="hourControl.sunFromTime.errors.required">Please fill this out</div>
            </div>
          </div>
          <div class="col-sm-4">
            <select formControlName="sunToTime" class="form-control input-sm" (change)="toHrOtherDay($event)">
              <option value="null" selected disabled>Closes</option>
              <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
            </select>
            <div class="error-msg" *ngIf="hourControl.sunToTime.invalid">
              <div *ngIf="hourControl.sunToTime.errors.required">Please fill this out</div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="text-right" style="padding-right: 46px;padding-top: 7px; padding-bottom: 7px;">
      <button class="btn default-btn " (click)="decline()">
        Cancel
      </button>
      <button class="btn primary-btn " style="margin-left:2%;" (click)="hourSave()">
        Submit
      </button>

    </div>
  </div>
</ng-template>

<ng-template #locationTemplate>

  <div class="common-header-flex">
    <div>Location Details</div>
    <button>
      <span (click)="modalRef.hide()" class="common-close">&times;</span>
    </button>
  </div>

  <div class="panel-body gs-card-bodygs-card-body">

    <div class="row">
      <form [formGroup]="locationForm" class="form-horizontal app-form">
        <div formArrayName="companyLocationDetails">
          <div *ngFor="let work of locationArray.controls; let i  = index; let lastItem = last;">
            <div [formGroupName]="i" class="form-horizontal">
              <div class="form-group row">
                <label for="address1" class="col-sm-3 control-label required-field font-normal">Address 1</label>
                <div class="col-sm-8">
                  <input type="text" maxlength="100" formControlName="address1" class="form-control input-sm"
                    placeholder="Door No, Building Name, Street Name" trim="blur"
                    [ngClass]="{ 'is-invalid': ldSubmit && getLocationFormgroup(i).controls['address1'].invalid }">
                  <div *ngIf="ldSubmit && getLocationFormgroup(i).controls['address1'].hasError ||
                                            getLocationFormgroup(i).controls['address1'].hasError &&
                                            (getLocationFormgroup(i).controls['address1'].dirty ||
                                            getLocationFormgroup(i).controls['address1'].touched) " class="error-msg">
                    <div *ngIf="getLocationFormgroup(i).controls['address1'].hasError('required')">
                      Address 1 is required</div>
                    <div *ngIf="getLocationFormgroup(i).controls['address1'].hasError('minword')">
                      {{FORMERROR.BUSINESS_ADDRESS_MIN}}</div>
                    <div *ngIf="getLocationFormgroup(i).controls['address1'].hasError('maxword')">
                      {{FORMERROR.BUSINESS_ADDRESS_MAX}}</div>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="address2" class="col-sm-3 control-label  font-normal">Address 2</label>
                <div class="col-sm-8">
                  <input type="text" maxlength="100" class="form-control input-sm" placeholder="" trim="blur"
                    formControlName="address2">
                </div>
              </div>

              <div class="form-group row" style="margin-bottom: 0px;">
                <label class="col-sm-3 control-label required-field font-normal">Location</label>
                <div class="col-sm-8">
                  <div class="row">
                    <div class="col-sm-6">
                      <select class="form-control input-sm m-b" formControlName="country"
                        (change)="onChangeCountry($event.target.value, i)"
                        [ngClass]="{ 'is-invalid': ldSubmit && getLocationFormgroup(i).controls['country'].invalid}">
                        <option value="null" selected disabled>Country</option>
                        <option *ngFor="let country of countryList" [value]="country.countryCode">
                          {{country.countryName}}</option>
                      </select>
                      <div style="margin-top: -15px;" *ngIf="ldSubmit && getLocationFormgroup(i).controls['country'].hasError ||
                                        getLocationFormgroup(i).controls['country'].hasError &&
                                        (getLocationFormgroup(i).controls['country'].dirty ||
                                        getLocationFormgroup(i).controls['country'].touched)" class="error-msg">
                        <div *ngIf="getLocationFormgroup(i).controls['country'].hasError('required')">
                          Country is required

                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6" *ngIf="companyLocationDetails.value[i].country=='US'">
                      <input type="text" maxlength="12" placeholder="Zipcode" formControlName="zipCode"
                        class="form-control input-sm" (keyup)="onKeyZip($event, i)"
                        [ngClass]="{ 'is-invalid': ldSubmit && getLocationFormgroup(i).controls['zipCode'].invalid }">
                      <div *ngIf="companyLocationDetails.value[i].country=='US'&&
                                (ldSubmit && getLocationFormgroup(i).controls['zipCode'].hasError ||
                                getLocationFormgroup(i).controls['zipCode'].hasError &&
                                (getLocationFormgroup(i).controls['zipCode'].dirty ||
                                getLocationFormgroup(i).controls['zipCode'].touched)) " class="error-msg">
                        <div *ngIf="getLocationFormgroup(i).controls['zipCode'].hasError('required')">
                          Zipcode is required</div>
                      </div>
                      <div class="error-msg" *ngIf="getLocationFormgroup(i).controls['zipCode'].hasError('minword')">
                        {{FORMERROR.ZIPCODE_MIN}}
                      </div>
                      <div class="error-msg" *ngIf="getLocationFormgroup(i).controls['zipCode'].hasError('maxword')">
                        {{FORMERROR.ZIPCODE_MAX}}
                      </div>
                    </div>

                    <div class="col-sm-6" *ngIf="companyLocationDetails.value[i].country=='CA'">
                      <select class="form-control input-sm" formControlName="state" type="text"
                        [ngClass]="{ 'is-invalid': ldSubmit && getLocationFormgroup(i).controls['state'].invalid }">
                        <option value="null" selected disabled>State</option>
                        <option *ngFor="let state of stateListCA" [value]="state.stateName">
                          {{state.stateName}}</option>
                      </select>

                      <div *ngIf="companyLocationDetails.value[i].country=='CA'&&
                             (ldSubmit && getLocationFormgroup(i).controls['state'].hasError ||
                             getLocationFormgroup(i).controls['state'].hasError &&
                             (getLocationFormgroup(i).controls['state'].dirty ||
                             getLocationFormgroup(i).controls['state'].touched)) " class="error-msg">
                        <div *ngIf="getLocationFormgroup(i).controls['state'].hasError('required')">
                          State is required</div>
                      </div>
                    </div>

                    <div class="col-sm-6" *ngIf="companyLocationDetails.value[i].country=='IN'">
                      <select class="form-control input-sm" formControlName="state" type="text"
                        [ngClass]="{ 'is-invalid': ldSubmit && getLocationFormgroup(i).controls['state'].invalid }">
                        <option value="null" selected disabled>State</option>
                        <option *ngFor="let state of stateListIN" [value]="state.stateName">
                          {{state.stateName}}</option>
                      </select>

                      <div *ngIf="companyLocationDetails.value[i].country=='IN'&&
                             (ldSubmit && getLocationFormgroup(i).controls['state'].hasError ||
                             getLocationFormgroup(i).controls['state'].hasError &&
                             (getLocationFormgroup(i).controls['state'].dirty ||
                             getLocationFormgroup(i).controls['state'].touched)) " class="error-msg">
                        <div *ngIf="getLocationFormgroup(i).controls['state'].hasError('required')">
                          State is required</div>
                      </div>
                    </div>

                    <div class="col-sm-6" *ngIf="companyLocationDetails.value[i].country=='AU'">
                      <select class="form-control input-sm" formControlName="state" type="text"
                        [ngClass]="{ 'is-invalid': ldSubmit && getLocationFormgroup(i).controls['state'].invalid }">
                        <option value="null" selected disabled>State</option>
                        <option *ngFor="let state of stateListAU" [value]="state.stateName">
                          {{state.stateName}}</option>
                      </select>

                      <div *ngIf="companyLocationDetails.value[i].country=='AU'&&
                                (ldSubmit && getLocationFormgroup(i).controls['state'].hasError ||
                                getLocationFormgroup(i).controls['state'].hasError &&
                                (getLocationFormgroup(i).controls['state'].dirty ||
                                getLocationFormgroup(i).controls['state'].touched)) " class="error-msg">
                        <div *ngIf="getLocationFormgroup(i).controls['state'].hasError('required')">
                          State is required</div>
                      </div>
                    </div>

                    <div class="col-sm-6" *ngIf="companyLocationDetails.value[i].country!='AU'&&
                                                        companyLocationDetails.value[i].country!='IN'&&
                                                        companyLocationDetails.value[i].country!='CA'&&
                                                        companyLocationDetails.value[i].country!='US'">
                      <input type="text" maxlength="51" placeholder="State" formControlName="state"
                        class="form-control input-sm"
                        [ngClass]="{ 'is-invalid': ldSubmit && getLocationFormgroup(i).controls['state'].invalid }">
                      <div *ngIf=" companyLocationDetails.value[i].country!='AU'&&
                                                    companyLocationDetails.value[i].country!='IN'&&
                                                    companyLocationDetails.value[i].country!='CA'&&
                                                    companyLocationDetails.value[i].country!='US'&&
                                        (ldSubmit && getLocationFormgroup(i).controls['state'].hasError||
                                        getLocationFormgroup(i).controls['state'].hasError &&(getLocationFormgroup(i).controls['state'].dirty ||
                                        getLocationFormgroup(i).controls['state'].touched)) " class="error-msg">
                        <div *ngIf="getLocationFormgroup(i).controls['state'].hasError('required')">
                          State is required</div>
                        <div *ngIf="getLocationFormgroup(i).controls['state'].hasError('maxword')">
                          {{FORMERROR.STATE_MAX}}</div>
                      </div>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col-sm-6" *ngIf="companyLocationDetails.value[i].country=='US'">
                      <input type="text" placeholder="City" maxlength="51" formControlName="city"
                        class="form-control input-sm"
                        [ngClass]="{ 'is-invalid': ldSubmit && getLocationFormgroup(i).controls['city'].invalid }">
                      <div *ngIf="ldSubmit && getLocationFormgroup(i).controls['city'].hasError ||
                                getLocationFormgroup(i).controls['city'].hasError &&
                                (getLocationFormgroup(i).controls['city'].dirty ||
                                getLocationFormgroup(i).controls['city'].touched) " class="error-msg">
                        <div *ngIf="getLocationFormgroup(i).controls['city'].hasError('required')">
                          City is required</div>
                        <div *ngIf="getLocationFormgroup(i).controls['city'].hasError('maxword')">
                          {{FORMERROR.CITY_MAX}}
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6" *ngIf="companyLocationDetails.value[i].country!='US'">
                      <input type="text" maxlength="51" placeholder="City" formControlName="city"
                        class="form-control input-sm"
                        [ngClass]="{ 'is-invalid': ldSubmit && getLocationFormgroup(i).controls['city'].invalid }">
                      <div *ngIf="ldSubmit && getLocationFormgroup(i).controls['city'].hasError ||
                                getLocationFormgroup(i).controls['city'].hasError &&
                                (getLocationFormgroup(i).controls['city'].dirty ||
                                getLocationFormgroup(i).controls['city'].touched) " class="error-msg">
                        <div *ngIf="getLocationFormgroup(i).controls['city'].hasError('required')">
                          City is required</div>
                        <div *ngIf="getLocationFormgroup(i).controls['city'].hasError('maxword')">
                          {{FORMERROR.CITY_MAX}}
                        </div>
                      </div>
                    </div>

                    <div *ngIf="companyLocationDetails.value[i].country!='US'" class="col-sm-6">
                      <input type="text" maxlength="12" placeholder="Zipcode" formControlName="zipCode"
                        class="form-control input-sm"
                        [ngClass]="{ 'is-invalid': ldSubmit && getLocationFormgroup(i).controls['zipCode'].invalid }">
                      <div *ngIf="ldSubmit && getLocationFormgroup(i).controls['zipCode'].hasError ||
                                getLocationFormgroup(i).controls['zipCode'].hasError &&
                                (getLocationFormgroup(i).controls['zipCode'].dirty ||
                                getLocationFormgroup(i).controls['zipCode'].touched) " class="error-msg">
                        <div *ngIf="getLocationFormgroup(i).controls['zipCode'].hasError('required')">
                          Zipcode is required</div>
                      </div>
                      <div class="error-msg" *ngIf="getLocationFormgroup(i).controls['zipCode'].hasError('minword')">
                        {{FORMERROR.ZIPCODE_MIN}}
                      </div>
                      <div class="error-msg" *ngIf="getLocationFormgroup(i).controls['zipCode'].hasError('maxword')">
                        {{FORMERROR.ZIPCODE_MAX}}
                      </div>
                    </div>

                    <div class="col-sm-6" *ngIf="companyLocationDetails.value[i].country=='US'">
                      <input type="text" maxlength="51" placeholder="State" formControlName="state"
                        class="form-control input-sm"
                        [ngClass]="{ 'is-invalid': ldSubmit && getLocationFormgroup(i).controls['state'].invalid }">
                      <div *ngIf="ldSubmit && getLocationFormgroup(i).controls['state'].hasError ||
                                getLocationFormgroup(i).controls['state'].hasError &&
                                (getLocationFormgroup(i).controls['state'].dirty ||
                                getLocationFormgroup(i).controls['state'].touched) " class="error-msg">
                        <div *ngIf="getLocationFormgroup(i).controls['state'].hasError('required')">
                          State is required </div>
                        <div *ngIf="getLocationFormgroup(i).controls['state'].hasError('maxword')">
                          {{FORMERROR.STATE_MAX}}
                        </div>
                      </div>
                    </div>

                  </div>



                  <div class="row">
                    <div class="col-sm-12">
                      <input type="text" maxlength="100" placeholder="Landmark (Optional)" formControlName="street"
                        class="form-control input-sm">
                      <small id="helpId" class="form-text text-muted">(Street/ Road/ Nearby location)</small>
                    </div>
                  </div>

                </div>
              </div>

              <div class="form-group row" *ngIf=" !hide ||  companyLocationDetails.value[i].headquarters==true">
                <label class="col-sm-3 control-label  font-normal">Headquarters</label>
                <div class="col-md-6">
                  <div class="custom-checkbox">
                    <label class="checkbox-label font-normal" style="text-align: center;">
                      <input type="checkbox" (change)="curOrg($event, i)" formControlName="headquarters"
                        name="headquarters">
                      <span style="margin-top: -7px;" title="Check if this is headquarters" class="checkmark"></span>
                    </label>
                  </div>

                  <div class="custom-checkbox"
                    *ngIf=" !hide &&  companyLocationDetails.value[i].headquarters==true">
                    <label class="checkbox-label" style="text-align: center;">
                      <input type="checkbox" (click)="changelocation($event,i)" formControlName="headquarters"
                        name="headquarters">
                      <span title="Check if this is headquarters" style="margin-top: -7px;" class="checkmark"></span>

                    </label>
                  </div>

                </div>
              </div>

              <div class="form-group row"
                *ngIf="locationEditFlag">
                <label class="col-sm-3 required-field control-label font-normal">Current Location</label>
                <div class="col-sm-6">
                  <div class="custom-checkbox" title="Check this if you want to keep this location as primary">
                    <label class="checkbox-label font-normal" style="text-align: center">
                      <!-- <div style="display: inline-block;"> -->
                      <input type="checkbox" formControlName="primary" (change)="keepPrimary($event, i)"
                        name="primary" />
                      <small style="position: relative; top: -6px;">By checking Current Location, this location
                        will be shown to public as your primary address</small>
                      <!-- </div> -->
                      <span class="checkmark" style="top: -5px"></span>
                    </label>
                    <div style="position: relative; float: left; margin-left: 17px;" *ngIf="
                          (ldSubmit &&
                            getLocationFormgroup(i).controls['primary']
                              .hasError) ||
                          (getLocationFormgroup(i).controls['primary']
                            .hasError &&
                            (getLocationFormgroup(i).controls['primary']
                              .dirty ||
                              getLocationFormgroup(i).controls['primary']
                                .touched))
                        " class="error-msg">
                      <div *ngIf="
                            getLocationFormgroup(i).controls[
                              'primary'
                            ].hasError('required')
                          ">
                        At least one current location is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="businessPhone" class="col-sm-3 required-field control-label font-normal">Business
                  Phone</label>
                <div class="col-sm-8">
                  <input type="text" (keypress)="digitKeyOnly($event)" maxlength="16" formControlName="businessPhone"
                    class="form-control input-sm" placeholder="Business Phone Number"
                    [ngClass]="{ 'is-invalid': ldSubmit && getLocationFormgroup(i).controls['businessPhone'].invalid}">

                  <div class="error-msg" *ngIf="ldSubmit && getLocationFormgroup(i).controls['businessPhone'].hasError ||
                                    getLocationFormgroup(i).controls['businessPhone'].hasError &&
                                    (getLocationFormgroup(i).controls['businessPhone'].dirty ||
                                    getLocationFormgroup(i).controls['businessPhone'].touched)">
                    <div *ngIf="getLocationFormgroup(i).controls['businessPhone'].hasError('maxword')">
                      {{FORMERROR.BUSINESSPHONE_MAX}}
                    </div>
                    <div *ngIf="getLocationFormgroup(i).controls['businessPhone'].hasError('minword')">
                      {{FORMERROR.BUSINESSPHONE_MIN}}
                    </div>
                    <div *ngIf="getLocationFormgroup(i).controls['businessPhone'].hasError('required')">
                      Business Phone is required
                    </div>
                  </div>
                  <div class="error-msg" *ngIf="getLocationFormgroup(i).controls['businessPhone'].hasError('pattern')">
                    {{FORMERROR.NUMBER_PATTERN}}</div>
                </div>
              </div>

              <div class="form-group row">
                <label for="website" class="col-sm-3 control-label required-field font-normal">Website</label>
                <div class="col-sm-8">
                  <input type="text" formControlName="website" class="form-control input-sm" placeholder="Website"
                    [ngClass]="{ 'is-invalid': ldSubmit && getLocationFormgroup(i).controls['website'].invalid}">
                  <div *ngIf="ldSubmit && getLocationFormgroup(i).controls['website'].hasError ||
                                        getLocationFormgroup(i).controls['website'].hasError &&
                                        (getLocationFormgroup(i).controls['website'].dirty ||
                                        getLocationFormgroup(i).controls['website'].touched)" class="error-msg">
                    <div *ngIf="getLocationFormgroup(i).controls['website'].hasError('required')">
                      Website is required</div>
                    <div *ngIf="getLocationFormgroup(i).controls['website'].hasError('pattern')">
                      Enter valid website format
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="businessEmail" class="col-sm-3 control-label required-field font-normal">Business
                  Email</label>
                <div class="col-sm-8">
                  <input disabled type="text" formControlName="businessEmail" class="form-control input-sm"
                    placeholder="Business Email"
                    [ngClass]="{ 'is-invalid': ldSubmit && getLocationFormgroup(i).controls['businessEmail'].invalid}">
                  <div *ngIf="ldSubmit && getLocationFormgroup(i).controls['businessEmail'].hasError ||
                                            (getLocationFormgroup(i).controls['businessEmail'].hasError &&
                                            (getLocationFormgroup(i).controls['businessEmail'].dirty ||
                                            getLocationFormgroup(i).controls['businessEmail'].touched))"
                    class="error-msg">
                    <div *ngIf="getLocationFormgroup(i).controls['businessEmail'].hasError('required')">
                      Business Email is required</div>
                    <div *ngIf="getLocationFormgroup(i).controls['businessEmail'].hasError('email')">
                      Please enter a valid email ID</div>
                    <div *ngIf="getLocationFormgroup(i).controls['businessEmail'].hasError('notSameDomain')">
                      Please enter a email domain that is same as the website domain </div>
                  </div>
                </div>
              </div>
            </div>
            <hr *ngIf="!lastItem">
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default " (click)="decline()">
          Cancel
        </button>

        <button class="btn primary-btn " [ngClass]="{'disabled': isClicked}" *ngIf="locationEditFlag" (click)="locationSave('edit')">
          Update
        </button>
        <button class="btn primary-btn" [ngClass]="{'disabled': isClicked}" *ngIf="locationAddFlag" (click)="locationSave('add')">
          Submit
        </button>
      </div>
    </div>
  </div>


</ng-template>


<ng-template #socialPresenceTemplate>

  <div class="common-header-flex">
    <div>Social Presence</div>
    <button type="button" (click)="modalRef.hide()">
      <span class="common-close">&times;</span>
    </button>
  </div>

  <div class="panel-body gs-card-bodygs-card-body">
    <form [formGroup]="userSocialPresenceForm" class="custom-form">
      <div class="row form-horizontal">
        <div class="form-group">
          <label for="socialLinkedinInput" class="col-sm-3 control-label">LinkedIn</label>
          <div class="col-sm-8">
            <input type="text" maxlength="100" class="form-control input-sm" placeholder="Linkedin"
              id="socialLinkedinInput" formControlName="linkedin">
            <div class="error-msg"
              *ngIf="userSocialPresenceForm.controls.linkedin.invalid && userSocialPresenceForm.controls.linkedin.errors?.pattern">
              {{FORMERROR.HTTP_VALID}}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="certificationName" class="col-sm-3 control-label">X</label>
          <div class="col-sm-8">
            <input type="text" maxlength="100" class="form-control input-sm" placeholder="X"
              formControlName="twitter">
            <div class="error-msg"
              *ngIf="userSocialPresenceForm.controls.twitter.invalid && userSocialPresenceForm.controls.twitter.errors?.pattern">
              {{FORMERROR.HTTP_VALID}}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="facebook" class="col-sm-3 control-label">Facebook</label>
          <div class="col-sm-8">
            <input type="text" maxlength="100" class="form-control input-sm" placeholder="Facebook"
              formControlName="facebook">
            <div class="error-msg"
              *ngIf="userSocialPresenceForm.controls.facebook.invalid && userSocialPresenceForm.controls.facebook.errors?.pattern">
              {{FORMERROR.HTTP_VALID}}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="blogURL" class="col-sm-3 control-label">Blog</label>
          <div class="col-sm-8">
            <input type="text" maxlength="100" class="form-control input-sm" placeholder="Blog"
              formControlName="blogURL">
            <div class="error-msg"
              *ngIf="userSocialPresenceForm.controls.blogURL.invalid && userSocialPresenceForm.controls.blogURL.errors?.pattern">
              {{FORMERROR.HTTP_VALID}}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="alternamePageLink" class="col-sm-3 control-label">Personal Website</label>
          <div class="col-sm-8">
            <input type="text" maxlength="100" class="form-control input-sm" placeholder="Personal Website"
              formControlName="alternamePageLink">
            <div class="error-msg"
              *ngIf="userSocialPresenceForm.controls.alternamePageLink.invalid && userSocialPresenceForm.controls.alternamePageLink.errors?.pattern">
              {{FORMERROR.HTTP_VALID}}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="youtube" class="col-sm-3 control-label">YouTube</label>
          <div class="col-sm-8">
            <input type="text" maxlength="100" class="form-control input-sm" placeholder="YouTube URL"
              formControlName="youtube">
            <div class="error-msg"
              *ngIf="userSocialPresenceForm.controls.youtube.invalid && userSocialPresenceForm.controls.youtube.errors?.pattern">
              {{FORMERROR.HTTP_VALID}}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="instagram" class="col-sm-3 control-label">Instagram</label>
          <div class="col-sm-8">
            <input type="text" maxlength="100" class="form-control input-sm" placeholder="Instagram URL"
              formControlName="instagram">
            <div class="error-msg"
              *ngIf="userSocialPresenceForm.controls.instagram.invalid && userSocialPresenceForm.controls.instagram.errors?.pattern">
              {{FORMERROR.HTTP_VALID}}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="tiktok" class="col-sm-3 control-label">TikTok</label>
          <div class="col-sm-8">
            <input type="text" maxlength="100" class="form-control input-sm" placeholder="TikTok URL"
              formControlName="tiktok">
            <div class="error-msg"
              *ngIf="userSocialPresenceForm.controls.tiktok.invalid && userSocialPresenceForm.controls.tiktok.errors?.pattern">
              {{FORMERROR.HTTP_VALID}}
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button type="button" class="btn btn-default " (click)="decline()">
          Cancel
        </button>
        <button type="button" class="btn primary-btn " (click)="userSocialPresenceSave()">
          Submit
        </button>
      </div>
    </div>
  </div>


</ng-template>
